import { EntityType } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';
import { customRoleRequest } from '@frontend/role/events';
import { CustomRole } from '@frontend/role/types';
import React from 'react';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import { ROLE_RIGHTS_LABEL, RoleDetailsCard, RoleLinkedSection, RoleRightsSection } from './role-detail-sections';

export const roleReactiveDetail: ReactiveDetailRegistryEntry<CustomRole> = {
    entityType: EntityType.ROLE,
    resolveFunction: customRoleRequest,
    title: ({ object }) => (
        <>
            {CommonMessage.OBJECTS.ROLE.DEFAULT}: {object.name}
        </>
    ),
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: ({ object }) => <RoleDetailsCard role={object} />
        },
        {
            id: 'rights',
            label: ROLE_RIGHTS_LABEL,
            render: ({ object }) => <RoleRightsSection role={object} />
        },
        {
            id: 'linked',
            label: CommonMessage.DETAIL.LINKED,
            render: ({ object }) => <RoleLinkedSection role={object} />
        }
    ]
};
